// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatProjectsPageGrid-modulegrid__jMFv7";
export { _1 as "grid" }
